export class PhoneTypeData {
    private phoneTypeList: string[] = ["Mobile", "Home", "Business", "Other"];

    public getPhoneTypeList(): Array<string> {
        return this.phoneTypeList;
    }
}